import React from "react";
import DateHelper from '../DateHelper/DateHelper';
import CalendarIcons from '../CalendarIcons/CalendarIcons';
import { isSameDay } from 'date-fns';
import numeral from "numeral";

class PreviewPopoverReservationSegment extends React.Component {
  constructor(props) {
    super(props)
  } 

  render() {
    var actions = []
    for (var i = 0, ilen = this.props.actions.length; i < ilen; i++) {
      var action = this.props.actions[i];
      this.props.folioTable
        ?
        actions.push(<div className="col-sm-6" key={i} style={i === 1 ? { padding: '0px' } : null}><a style={{ padding: '0px', fontWeight: '550' }} href={`${action.path}`} className='btn-sm modal-iframe' data-nested='true' data-fullscreen='true'>{I18n.t(action.name)}</a></div>)
        :
        actions.push(<a style={{ fontWeight: '550' }} key={i} href={`${action.path}`} className='btn-sm modal-iframe' data-nested='true' data-fullscreen='true'>{I18n.t(action.name)}</a>)
    }
    var identifier = ""
    if (this.props.room) {
      identifier = this.props.room.identifier
    } else if (this.props.room_group) {
      identifier = this.props.room_group.identifier
    }

    var reservation_segment = this.props

    var check_in_date = DateHelper.parseDateFromBackend(this.props.check_in_date);
    var check_out_date = DateHelper.parseDateFromBackend(this.props.check_out_date);
    var checked_in_at = this.props.checked_in_at ? DateHelper.parseDateFromBackend(this.props.checked_in_at) : null;
    var checked_out_at = this.props.checked_out_at ? DateHelper.parseDateFromBackend(this.props.checked_out_at) : null;
    var todaysDate = DateHelper.today();

    var check_in_today = isSameDay(check_in_date, todaysDate)
    var check_out_today = isSameDay(check_out_date, todaysDate);
    var phone_number = `tel:${this.props.customer.phone_number}`
    var email = `mailto: ${this.props.customer.email}`

    var status = ""

    if (reservation_segment.status == 'canceled' && reservation_segment.is_balanced === true) {
      status = <div style={{ color: 'green' }}>{I18n.t('canceled_is_balanced')}</div>
    } else if (reservation_segment.status == 'canceled' && reservation_segment.is_balanced === false) {
      status = <div style={{ color: 'red' }}>{I18n.t('canceled_out_of_balance')}</div>
    } else if (checked_out_at) {
      status = <div>{I18n.t('checked_out_at', { date: DateHelper.printDateToScreen(checked_out_at, this.props.date_format + ' - ' + this.props.time_format) })}</div>

    } else if (check_out_today) {
      if (checked_in_at) {
        status = <div>{I18n.t('check_out_today')}</div>
      } else {
        status = <div>{I18n.t('no_show')} - {I18n.t('check_out_today')}</div>
      }
    } else if (reservation_segment.room_status == "no_show") {
      status = <div>{I18n.t('no_show')}</div>
    } else if (checked_in_at && !checked_out_at && check_out_date < todaysDate) {
      status = <div>{I18n.t('missed_check_out')}</div>
    } else if (checked_in_at) {
      status = <div>{I18n.t('checked_in_at', { date: DateHelper.printDateToScreen(checked_in_at, this.props.date_format + ' - ' + this.props.time_format) })}</div>
    } else if (check_in_today) {
      status = <div>{I18n.t('check_in_today')}</div>

    } else if (todaysDate > check_in_date) {
      status = <div>{I18n.t('missed_check_in')}</div>
    } else {
      status = <div>{I18n.t(`${reservation_segment.status}`)}</div>
    }

    return (
      <div className="popover-preview">
        <div className="popover-close-wrapper"><button type="button" className="close" onClick={$(this).parents('.popover').popover('hide')}><span aria-hidden="true">x</span><span className="sr-only">Close</span></button></div>

        <div className='popover-heading'>
          <h3 className={this.props.calendarIcons ? 'icon-header' : null}><div className="model-card" style={{ paddingLeft: '10px' }}><span className="ss-contacts">&nbsp;</span></div><a href={this.props.edit_admin_reservation_path} className="modal-iframe" data-nested='true' data-fullscreen='true'>{this.props.folioTable ? this.props.text : this.props.reservation.confirmation_number}</a>{this.props.calendarIcons ? <CalendarIcons {...this.props} /> : null}</h3>
        </div>

        <div className="popover-body" style={this.props.popoverBodyWidth ? { width: this.props.popoverBodyWidth + 'px' } : null}>
          <div className="row">
            <div className="col-sm-6">
              <label>{I18n.t('customer')}</label>
              <div className="value">{this.props.customer ? this.props.customer.full_name : I18n.t('none')}</div>
            </div>
            <div className="col-sm-6">
              <label>{I18n.t('number_of_nights')}</label>
              <div className="value">{this.props.number_of_nights}</div>
            </div>
            {/* <div className="col-sm-6">
              <label>{I18n.t('arrival')}</label>
              <div className="value">{DateHelper.printDateToScreen(check_in_date, this.props.date_format)}</div>

            </div>
            <div className="col-sm-6">
              <label>{I18n.t("departure")}</label>
              <div className="value">{DateHelper.printDateToScreen(check_out_date, this.props.date_format)}</div>
            </div> */}
          </div>
          <div className="row">
            <div className="col-sm-6">
              <label>{I18n.t('email')}</label>
              <div className="value"><a href={email}>{this.props.customer.email}</a></div>
            </div>
            <div className="col-sm-6">
              <label>{I18n.t('phone')}</label>
              <div className="value"><a href={phone_number}>{this.props.customer.formatted_phone}</a></div>
            </div>
            {/* <div className="col-sm-6">
              <label>{I18n.t('room_status')}</label>
              <div className="value">{status}</div>
            </div> */}

          </div>
          <div className="row">
            <div className="col-sm-6">
              <label>{I18n.t('rate')}</label>
              <div className="value">{this.props.rate.code}</div>
            </div>
            <div className="col-sm-6">
              <label>{I18n.t('source')}</label>
              <div className="value">{this.props.reservation.source_name}</div>
            </div>


          </div>
          <div className="row">
            <div className="col-sm-6">
              <label>{I18n.t('total_amount')}</label>
              <div className="value">{this.formatCurrency(this.props.total_amount)}</div>
            </div>
            <div className="col-sm-6">
              <label>{I18n.t('balance')}</label>
              <div className="value">{this.formatCurrency(this.props.balance_amount)}</div>
            </div>

          </div>

          <hr style={{ margin: '0px 0 0px 0' }} />
          <div className={this.props.folioTable ? "row" : "quick-links"}>{actions}</div>
        </div>
      </div>
    )
  }

  formatCurrency = (num) => {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };
}

export default PreviewPopoverReservationSegment
